export * from "./geodesy.js";
export * from "./state-source.js";
export * from "./local-sim-source.js";
export * from "./behaviours/index.js";
export * from "./coastline-router.js";
export * from "./recording.js";
export * from "./replay-source.js";
export * from "./durable-object-source.js";
export * from "./snapshot-buffer.js";

import { registerBuiltInBehaviours } from "./behaviours/index.js";

registerBuiltInBehaviours();
